import { Navigate, RouteObject } from 'react-router-dom'

import Layout from '@/components/layout/Layout'
import Portfolio from '@/pages/portfolio/Portfolio'

import FrontPage from '@/pages/frontpage/FrontPage'
import User from '@/pages/user/User'
import About from '@/pages/about/About'
import Dashboard from '@/features/dashboard/pages/Dashboard'
import HowToGetStarted from '@/pages/howToGetStarted/howToGetStarted'
import TrendPage from '@/pages/trends/Trend'
import PlantStatus from '@/features/status/pages/PlantStatus'

export const routes: RouteObject[] = [
    {
        path: '/',
        element: <Layout />,
        handle: 'FrontPage',
        children: [
            { index: true, element: <FrontPage /> },
            { path: 'frontpage', element: <FrontPage /> },
            { path: 'about', element: <About /> },
            { path: 'howto', element: <HowToGetStarted /> },
            { path: 'portfolio/*', element: <Portfolio /> },
            { path: 'status', element: <PlantStatus /> },
            { path: 'dashboard/:sensorTag?', element: <Dashboard /> },
            { path: 'user', element: <User /> },
            { path: 'trends/:timeSeriesTableIds?', element: <TrendPage /> },
            { path: 'trends/:timeSeriesTableIds/:pollLatest', element: <TrendPage /> },
            { path: 'trends/:timeSeriesTableIds/:pollLatest/:yAxisLabel', element: <TrendPage /> },
            { path: 'trends/:timeSeriesTableIds/:pollLatest/:yAxisLabel/:alarmLevel', element: <TrendPage /> },
            {
                path: 'trends/:timeSeriesTableIds/:pollLatest/:yAxisLabel/:alarmLevel/:showAlarm',
                element: <TrendPage />,
            },
            {
                path: 'trends/:timeSeriesTableIds/:pollLatest/:yAxisLabel/:alarmLevel/:showAlarm/:screenTitle',
                element: <TrendPage />,
            },
            {
                path: 'trends/:timeSeriesTableIds/:pollLatest/:yAxisLabel/:alarmLevel/:showAlarm/:screenTitle/:fromDate',
                element: <TrendPage />,
            },
            { path: '*', element: <Navigate to="/" /> },
        ],
    },
    {
        path: '/trends-own/:timeSeriesTableIds/:pollLatest/:yAxisLabel/:alarmLevel/:showAlarm/:screenTitle',
        element: <TrendPage />,
    },
    {
        path: '/trends-own/:timeSeriesTableIds/:pollLatest/:yAxisLabel/:alarmLevel/:showAlarm/:screenTitle/:fromDate',
        element: <TrendPage />,
    },
    { path: '/trends-own/:timeSeriesTableIds/:pollLatest/:yAxisLabel/:alarmLevel/:showAlarm', element: <TrendPage /> },
    { path: '/trends-own/:timeSeriesTableIds/:pollLatest/:yAxisLabel/:alarmLevel', element: <TrendPage /> },
    { path: '/trends-own/:timeSeriesTableIds/:pollLatest/:yAxisLabel', element: <TrendPage /> },
    { path: '/trends-own/:timeSeriesTableIds/:pollLatest', element: <TrendPage /> },
    { path: '/trends-own/:timeSeriesTableIds?', element: <TrendPage /> },
]
